// ============================================================================
// FSA ROUNDING FACTOR SERVICE  (FSA-2.2)
// ============================================================================
// Read-only lookup for rounding-factor options. Populates the dropdown in
// the FSA Settings modal. Source: common.tbl_enum_master where enum_group
// = 'ROUNDING_FACTOR'.

import { get } from '../../client/axiosClient';
import { buildEndpoint } from '../../endpoints/base.endpoints';
import type { ApiResponse } from '../../types';
import type { FsaRoundingFactor } from '../../types/fsa/engagementSettings.types';

class FsaRoundingFactorService {
  async getAll(): Promise<ApiResponse<FsaRoundingFactor[]>> {
    const r = await get<ApiResponse<FsaRoundingFactor[]>>(buildEndpoint('/FsaRoundingFactors'));
    return r.data;
  }
}

export const fsaRoundingFactorService = new FsaRoundingFactorService();
export default fsaRoundingFactorService;
